import React, { useEffect, useRef, useState, useMemo } from "react";
import { IonPage } from "@ionic/react";
import { Row, Col } from "antd";

//
import _ from "lodash";

//
import ShopProfile from "../ShopProfile";

const RequestDetailEdit = ({ state = {}, brand, company }) => {
  const { data, form, onChange } = state;

  return (
    <Row justify="start" style={{ width: "100%", margin: "1rem 0 5rem 0" }}>
      <Col span={12}>
        <ShopProfile
          state={{
            data: data,
            form: form,
            onChange: (value) => {
              // Handler to wrap data into the 'shop' object
              onChange({
                shop: {
                  ...value,
                },
              });
            },
          }}
          brand={brand}
          readOnly={false} // Explicitly set to false for editable mode
        />
      </Col>

      <Col span={11}>
        {/* {!brand && data?.type == "new" ? null : (
          <BrandProfile
            state={{
              data: brand,
              form: brandForm,
              onChange: updateBrandData,
            }}
            readOnly={false} // Explicitly set to false for editable mode
          />
        )}

        {!company && data?.type == "new" ? null : (
          <CompanyProfile
            state={{
              data: company,
              form: companyForm,
              onChange: updateCompanyData,
            }}
            readOnly={false} // Explicitly set to false for editable mode
          />
        )} */}
      </Col>
    </Row>
  );
};

export default RequestDetailEdit;
